module.exports = __webpack_public_path__ + "static/img/cgy61.862ac62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cgy61.png
// module id = e145
// module chunks = 73